import { Link } from "../link";

import { OrderedList, ListItem } from "ui/list";
import { Strong } from "ui/strong";

export const CreateAPIKeySnippet = () => (
  <OrderedList>
    <ListItem>
      From the{" "}
      <Link
        href="https://app.hightouch.com/settings/api-keys?from=docs"
        variant="inline"
      >
        <Strong>API keys</Strong> tab
      </Link>{" "}
      on the <Strong>Settings</Strong> page, click <Strong>Add API key</Strong>.
    </ListItem>
    <ListItem>
      Enter a descriptive <Strong>Name</Strong> for your key.
    </ListItem>
    <ListItem>
      Under <Strong>User group</Strong>, select the group whose permissions the
      key should have in this workspace, or select{" "}
      <Strong>All of the creator's groups</Strong> to give the key the same
      permissions as you.
    </ListItem>
    <ListItem>
      Copy your <Strong>API key</Strong> and store it in a safe location. The
      key is only displayed once.
    </ListItem>
    <ListItem>
      Click <Strong>Create API key</Strong>.
    </ListItem>
  </OrderedList>
);
